module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: _vm.recipe.id
        }
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaRecipe($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.recipe.image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num"
  }, [_vm._v(_vm._s(_vm.index + 1))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.recipe.title))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.recipe.portion) + " порции")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.recipe.time) + " минут")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53a24a72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Recipe.vue
// module id = 98
// module chunks = 0